import React, { useEffect, useState } from "react";
import styles from "../styles/progress.module.css";
import { Typography, Box, Link } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import InfoIcon from "@mui/icons-material/Info";
import * as Cts from "../nexus/constants.js";
const ProgressComponent = () => {
  const [progress, setProgress] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const [deletingText, setDeletingText] = useState("Deleting");
  const date = queryParams.get("date");
  useEffect(() => {
    const totalDuration = 6000;
    const textChangeTime = 3000;

    const interval = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress >= 100) {
          clearInterval(interval);
          return 100;
        }
        return oldProgress + 1;
      });
    }, totalDuration / 100); // Adjust interval to achieve 100% in 5 seconds

    // Change text to "Successfully Deleted" after 4 seconds and stop the progress bar
    const textTimeout = setTimeout(() => {
      setDeletingText("Successfully Deleted");
      setProgress(100); // Stop the progress bar at 4 seconds
    }, textChangeTime);

    // Redirect after 5 seconds
    const redirectTimeout = setTimeout(() => {
      navigate("/"); // Redirect after 5s
    }, totalDuration);

    return () => {
      clearInterval(interval);
      clearTimeout(textTimeout);
      clearTimeout(redirectTimeout);
    };
  }, [navigate]);

  return (
    <div className={styles.container}>
      <div className={styles.progressHead}>
        <Typography
          variant="h4"
          className={`${styles.deletingText} ${
            deletingText === "Successfully Deleted" ? styles.blinking : ""
          }`}
        >
          {deletingText}{" "}
          <span className={styles.highlight}>
            LXRP: Monthly Report Period {date}
          </span>
        </Typography>
        <Typography variant="h4" className={styles.redirectText}>
          You will be redirected to the Home page shortly...
        </Typography>
      </div>
      <Box className={styles.progressBarContainer}>
        <Box className={styles.progressBar} style={{ width: `${progress}%` }} />
      </Box>

      <Box className={styles.recoveryTip}>
        <div className={styles.iconAndTitle}>
          <InfoIcon className={styles.recoveryIcon} />
          <Typography variant="h4" className={styles.recoveryTitle}>
            Recovery Tip
          </Typography>
        </div>
        <Typography variant="h5" className={styles.recoveryText}>
          If you would like to recover this report, please raise an
          <Link
            onClick={(e) => {
              e.preventDefault();
              window.open(Cts.ticketURL, "_blank");
            }}
            className={styles.link}
          >
            {" "}
            IT Service Desk
          </Link>{" "}
          request using the Reporting & Dashboards menu. The Business
          Intelligence team will restore the report.
        </Typography>
      </Box>
    </div>
  );
};

export default ProgressComponent;
